export const HELP_CENTER_CATEGORY_PARAMS: HelpCenterCategoryParams = {
  needSubCategories: true
}

export const HELP_CENTER_MAIN_CATEGORIES_PLACEHOLDER = [
  { id: '1' },
  { id: '2' },
  { id: '3' },
  { id: '4' },
  { id: '5' },
  { id: '6' },
  { id: '7' },
  { id: '8' },
  { id: '9' }
] as unknown as HelpCenterCategoryModel[]

export const HELP_CENTER_SEARCH_ARTICLES_PLACEHOLDER = {
  articles: [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }]
} as unknown as HelpCenterPreviewArticlePaginationModel
